/**
 * Report template definitions for the Report Templates page.
 * Each entry carries richer metadata than Document Library entries
 * (badge, description, tags) while remaining compatible with
 * DocumentDraftModal via the standard { id, title, section, tag } shape.
 */

export const REPORT_CATEGORIES = [
  { id: 'all',   label: '📋 All Reports' },
  { id: 'board', label: '📊 Board Reports' },
  { id: 'audit', label: '🔍 Audit Reports' },
  { id: 'other', label: '📋 Other' },
];

export const REPORT_TEMPLATES = [
  // ── Board Reports ──────────────────────────────────────────────────
  {
    id: 'board_report_pvt',
    category: 'board',
    icon: '📊',
    title: "Board's Report — Private Limited Company",
    badge: { text: 'UPDATED FY 2024-25', color: 'green' },
    description:
      'Comprehensive Board Report template covering all mandatory disclosures u/s 134 of the Companies Act, 2013. Includes all amendments up to Companies (Amendment) Act 2020, CARO 2020, and applicable rules.',
    tags: ['u/s 134', 'Rule 8 of Companies (Accounts) Rules', 'Private Limited', 'FY 2024-25'],
    section: 'u/s 134(3) · AOC-4',
    tag: 'Report',
    hasPreview: true,
  },
  {
    id: 'board_report_opc',
    category: 'board',
    icon: '👤',
    title: "Board's Report — OPC (One Person Company)",
    badge: { text: 'UPDATED', color: 'orange' },
    description:
      'Simplified Board Report for OPC. Excludes AGM-related disclosures. Covers mandatory items u/s 134 applicable to OPC. Cash Flow Statement exemption included.',
    tags: ['u/s 134', 'OPC', 'Small Company', 'FY 2024-25'],
    section: 'u/s 134(3) · OPC Exemptions',
    tag: 'Report',
    hasPreview: true,
  },

  // ── Audit Reports ──────────────────────────────────────────────────
  {
    id: 'auditor_report_pvt',
    category: 'audit',
    icon: '🔍',
    title: "Independent Auditor's Report — Pvt LTD Company",
    badge: { text: 'CARO 2020', color: 'blue' },
    description:
      "Statutory Auditor's Report as per SA 700, SA 705, SA 706. Includes full CARO 2020 reporting. Updated for amendments effective FY 2024-25. Covers going concern, internal control, ICFR reporting.",
    tags: ['u/s 143', 'SA 700 Series', 'CARO 2020', 'ICFR', 'FY 2024-25'],
    section: 'u/s 143 · CARO 2020',
    tag: 'Report',
    hasPreview: true,
  },
  {
    id: 'secretarial_audit_mr3',
    category: 'audit',
    icon: '📋',
    title: 'Secretarial Audit Report — MR-3',
    badge: { text: 'UPDATED', color: 'orange' },
    description:
      'Secretarial Audit Report format as prescribed under Rule 9 of Companies (Appointment and Remuneration of Managerial Personnel) Rules, 2014. Updated per ICSI guidelines.',
    tags: ['u/s 204', 'Form MR-3', 'Listed / \u2265250 Cr PUC'],
    section: 'u/s 204 · Form MR-3',
    tag: 'Report',
    hasPreview: true,
  },
];

/* ── Legacy ID mapping for backward compatibility ───────────────── */
const LEGACY_ID_MAP = {
  board_report: 'board_report_pvt',
  companies_audit_report: 'auditor_report_pvt',
};

/**
 * Look up a report template by ID, supporting legacy IDs from
 * cached drafts in MyDocumentsPage / IndexedDB.
 */
export function getReportTemplateById(id) {
  const canonicalId = LEGACY_ID_MAP[id] || id;
  return REPORT_TEMPLATES.find((rt) => rt.id === canonicalId) || null;
}
